type GoodFormOnFileStatus =
    | {
          isComplete: false;
          earliestRecheckedDate: null;
      }
    | {
          isComplete: true;
          earliestRecheckedDate: Date;
      };

interface AppointmentRecheck {
    consent_form_rechecked?: Date | null;
}

export function getGoodFormOnFileStatus(
    heldAppointmentIds: string[],
    appointmentChecks: Record<string, AppointmentRecheck> = {}
): GoodFormOnFileStatus {
    if (heldAppointmentIds.length === 0) {
        return {
            isComplete: false,
            earliestRecheckedDate: null,
        };
    }

    const recheckedDates = heldAppointmentIds
        .map((id) => appointmentChecks[id]?.consent_form_rechecked)
        .filter((date): date is Date => Boolean(date));

    if (recheckedDates.length !== heldAppointmentIds.length) {
        return {
            isComplete: false,
            earliestRecheckedDate: null,
        };
    }

    return {
        isComplete: true,
        earliestRecheckedDate: recheckedDates.reduce((earliest, current) =>
            current.getTime() < earliest.getTime() ? current : earliest
        ),
    };
}
